import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.removeAttachmentIcon()
    }, 0)
  }

  removeAttachmentIcon() {
    const toolbar = this.element.querySelector("trix-toolbar")
    if (toolbar) {
      const attachmentButton = toolbar.querySelector("button[title='Attach Files']")
      if (attachmentButton) {
        attachmentButton.remove()
      }
    }
  }
}
